import { useEffect } from 'react';

/**
 * Dismiss-on-Escape for modals/overlays (NCP-4895). Calls `handler` when the
 * Escape key is pressed. Pass `undefined` (or `enabled = false`) to opt out —
 * e.g. when a modal has no cancel affordance, or a cancel is disabled while an
 * action is in flight — so Escape mirrors the Cancel button exactly.
 */
export function useEscapeKey(handler?: () => void, enabled = true): void {
  useEffect(() => {
    if (!enabled || !handler) {
      return undefined;
    }
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        handler();
      }
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [handler, enabled]);
}

export default useEscapeKey;
